import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', href: '/' },
  { label: '网红塌房', href: '/category/wanghong-tafang' },
  { label: '黑料爆料', href: '/category/heiliao-baoliao' },
  { label: '每日大赛', href: '/category/meiri-dasai' },
  { label: '娱乐八卦', href: '/category/yule-bagua' },
  { label: '直播吃瓜', href: '/category/zhibo-chigua' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="font-heading text-2xl text-primary-500 whitespace-nowrap">吃瓜一线</span>
            <span className="hidden sm:inline text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">线路一</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === item.href
                    ? 'text-primary-500 font-medium bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-3 shrink-0">
            <Link
              to="/category/heiliao-baoliao"
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              最新黑料 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-3 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                  location.pathname === item.href
                    ? 'text-primary-500 font-medium bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/category/heiliao-baoliao"
              className="bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 text-center mt-2 cursor-pointer whitespace-nowrap"
            >
              最新黑料 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}